import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-blank-template',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './blank-template.html',
  styleUrl: './blank-template.scss',
})
export class BlankTemplate {

}
